// Tones match the landing hero (HeroIso): three flat steps from one top-left light, no outlines.
.illustration {
  --iso-top: #fff;
  --iso-side-left: #e8ebf3;
  --iso-side-right: #d8dce8;
  --iso-shadow: #1c2140;
  --iso-shadow-opacity: 0.14;
  --iso-track: color-mix(in srgb, var(--color-primary) 6%, #e3e6ee);
  --iso-accent-top: color-mix(in srgb, var(--color-primary) 82%, #fff);

  display: block;
  width: 100%;
  height: auto;
  overflow: visible;
  user-select: none;
  pointer-events: none;

  g {
    transform-box: fill-box;
    transform-origin: center;
  }
}

:global([data-theme="dark"]) .illustration {
  --iso-top: #2a313c;
  --iso-side-left: #1f252e;
  --iso-side-right: #181d25;
  --iso-shadow: #000;
  --iso-shadow-opacity: 0.45;
  --iso-track: #2b323d;
  --iso-accent-top: var(--color-primary);
}

.top {
  fill: var(--iso-top);
}

.accentTop {
  fill: var(--iso-accent-top);
}

.sideLeft {
  stop-color: var(--iso-side-left);
}

.sideRight {
  stop-color: var(--iso-side-right);
}

.accentSideLeft {
  stop-color: color-mix(in srgb, var(--iso-accent-top) 85%, #000);
}

.accentSideRight {
  stop-color: color-mix(in srgb, var(--iso-accent-top) 70%, #000);
}

.shadow,
.softShadow {
  fill: var(--iso-shadow);
  opacity: var(--iso-shadow-opacity);
}

.softShadow {
  opacity: calc(var(--iso-shadow-opacity) * 0.7);
}

.track,
.trackFaint {
  fill: none;
  stroke: var(--iso-track);
  stroke-width: 3;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.trackFaint {
  stroke-dasharray: 0.1 7;
}

.padFill {
  fill: color-mix(in srgb, var(--color-primary) 5%, var(--color-background));
}

.padOutline {
  fill: none;
  stroke: color-mix(in srgb, var(--color-primary) 45%, var(--color-background));
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2;
  stroke-dasharray: 0.1 7;
}

.code {
  fill: var(--color-primary);
  font-family: var(--font-display-family), sans-serif;
  font-size: 34px;
  font-weight: 800;
  letter-spacing: -0.02em;
}

.glyph,
.glyphOnAccent {
  fill: none;
  stroke: var(--color-primary);
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.glyphOnAccent {
  stroke: #fff;
}

.ring {
  fill: none;
  stroke: color-mix(in srgb, var(--color-primary) 55%, transparent);
  stroke-width: 1.5;
}

.packetDot {
  fill: var(--color-primary);
}

.dim {
  opacity: 0.55;
}

// Motion is slow and small: the scenes should feel calm, like the hero.
.hover {
  animation: hover 4s ease-in-out infinite;
}

.hoverShadow {
  animation: hover-shadow 4s ease-in-out infinite;
}

.pulse {
  animation: pulse 3.2s ease-out infinite;
}

.rock {
  animation: rock 5s ease-in-out infinite;
}

.settle {
  animation: settle 6s cubic-bezier(0.65, 0, 0.35, 1) infinite;
}

.packet {
  animation: packet 3s cubic-bezier(0.45, 0, 0.55, 1) infinite;
}

@keyframes hover {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-7px);
  }
}

@keyframes hover-shadow {
  0%,
  100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(0.88);
    opacity: 0.7;
  }
}

@keyframes pulse {
  0% {
    transform: scale(0.9);
    opacity: 0.9;
  }
  100% {
    transform: scale(1.25);
    opacity: 0;
  }
}

@keyframes rock {
  0%,
  100% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(-3px, 1.5px);
  }
}

@keyframes settle {
  0%,
  15% {
    transform: translateY(-16px);
  }
  45%,
  75% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-16px);
  }
}

// Along the track's screen direction (down-right), fading out where the route breaks.
@keyframes packet {
  0% {
    transform: translate(0, 0);
    opacity: 0;
  }
  15% {
    opacity: 1;
  }
  70% {
    opacity: 1;
  }
  100% {
    transform: translate(40px, 23px);
    opacity: 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .illustration g {
    animation: none;
  }
}
